
let portrait = {
    "Overview": {
      id: "Overview",
      primary: 'Overview',
      provider: 'Community',
      ex_link:'https://en.wikipedia.org/wiki/Pf%C3%A4ffikon,_Schwyz',
      selected: true,
    },
    "Groups": {
      id: "Groups",
      primary: 'Groups',
      provider: 'Community',
      link:'notReady/',
      selected: false,
    },
    "Announcements":{
      id: "Announcements",
      primary: 'Announcements',
      provider: 'Community',
      link:'alerts/',
      selected: true,
    },
    "Events": {
        id: "Events",
        primary: 'Events',
        provider: 'Community',
        link:'notReady/',
        selected: true,
      },
    };

export default portrait;